"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { Trophy } from 'lucide-react';
import { cn } from '@/lib/utils';

// Constants
const GlbPlayerTeam = {
  HOME: {
    name: "HOME",
    value: 1
  },
  VISITOR: {
    name: "VISITOR",
    value: 2
  },
  UNDEFINED: {
    name: "UNDEFINED",
    value: 0
  }
};
interface BillboardScoreboardProps {
  gameState: any; // GameStateSnapshotv2.state
  playersData: any; // gamePlayersData
  settingsData: any; // gameSettingsData
  sport: string;
}
export function BillboardScoreboard(t0) {
  const $ = _c(94);
  const {
    gameState,
    playersData,
    settingsData,
    sport
  } = t0;
  if (!gameState) {
    return null;
  }
  gameState.currentSet || 1;
  const matchFinished = gameState.matchFinished || false;
  const teamServing = gameState.teamServing || 0;
  const homeSets = gameState.scoreSet?.[GlbPlayerTeam.HOME.name] || 0;
  const visitorSets = gameState.scoreSet?.[GlbPlayerTeam.VISITOR.name] || 0;
  const homePointsRaw = gameState.scorePoint?.[GlbPlayerTeam.HOME.name] || 0;
  const visitorPointsRaw = gameState.scorePoint?.[GlbPlayerTeam.VISITOR.name] || 0;
  const isTieBreak = gameState.inTieBreak || gameState.inSuperTieBreak;
  let homePointStr;
  let visitorPointStr;
  if (isTieBreak) {
    const t1 = gameState.scoreTieBreak?.[GlbPlayerTeam.HOME.name] || 0;
    let t2;
    if ($[0] !== t1) {
      t2 = t1.toString();
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    homePointStr = t2;
    const t3 = gameState.scoreTieBreak?.[GlbPlayerTeam.VISITOR.name] || 0;
    let t4;
    if ($[2] !== t3) {
      t4 = t3.toString();
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    visitorPointStr = t4;
  } else {
    const fmt = _temp;
    let t1;
    if ($[4] !== homePointsRaw || $[5] !== visitorPointsRaw) {
      t1 = fmt(homePointsRaw, visitorPointsRaw);
      $[4] = homePointsRaw;
      $[5] = visitorPointsRaw;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    const hStr = t1;
    let t2;
    if ($[7] !== homePointsRaw || $[8] !== visitorPointsRaw) {
      t2 = fmt(visitorPointsRaw, homePointsRaw);
      $[7] = homePointsRaw;
      $[8] = visitorPointsRaw;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    const vStr = t2;
    if (hStr === "Ad") {
      homePointStr = "Ad";
      visitorPointStr = "";
    } else {
      if (vStr === "Ad") {
        homePointStr = "";
        visitorPointStr = "Ad";
      } else {
        homePointStr = hStr;
        visitorPointStr = vStr;
      }
    }
  }
  const setsCount = typeof settingsData?.setCount === "number" ? settingsData.setCount : typeof settingsData?.setCount === "string" ? parseInt(settingsData.setCount) : 1;
  let data;
  if ($[10] !== gameState.scoreGame || $[11] !== matchFinished || $[12] !== setsCount) {
    data = [];
    for (let i = 1; i <= setsCount; i++) {
      const setKey = `set${i}`;
      const scores = gameState.scoreGame?.[setKey];
      const h = scores?.[GlbPlayerTeam.HOME.name] || 0;
      const v = scores?.[GlbPlayerTeam.VISITOR.name] || 0;
      if (matchFinished && h === 0 && v === 0) {
        continue;
      }
      data.push({
        setNum: i,
        h,
        v
      });
    }
    $[10] = gameState.scoreGame;
    $[11] = matchFinished;
    $[12] = setsCount;
    $[13] = data;
  } else {
    data = $[13];
  }
  const setsData = data;
  const homeWon = matchFinished && homeSets > visitorSets;
  const visitorWon = matchFinished && visitorSets > homeSets;
  const isHomeServing = teamServing === GlbPlayerTeam.HOME.value;
  const isVisitorServing = teamServing === GlbPlayerTeam.VISITOR.value;
  const oneVsOne = settingsData?.oneVsOne === true || settingsData?.oneVsOne === "true";
  let t1;
  if ($[14] !== playersData) {
    t1 = spot => {
      if (!playersData) {
        return null;
      }
      return Object.values(playersData).find(p_0 => {
        const s = typeof p_0.fldPlayerCourtSpot === "string" ? parseInt(p_0.fldPlayerCourtSpot) : p_0.fldPlayerCourtSpot;
        return s === spot;
      }) as any;
    };
    $[14] = playersData;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const getPlayerData = t1;
  let t2;
  if ($[16] !== getPlayerData || $[17] !== oneVsOne) {
    t2 = t3 => {
      const {
        spot: spot_0,
        align: t4,
        colorClass
      } = t3;
      const align = t4 === undefined ? "left" : t4;
      if (oneVsOne && (spot_0 === 2 || spot_0 === 4)) {
        return <div className="hidden" />;
      }
      const player = getPlayerData(spot_0);
      const name = player?.fldPlayerDisplayName && player.fldPlayerDisplayName !== "MVPlayer" && player.fldPlayerDisplayName !== "Empty slot..." ? player.fldPlayerDisplayName : "MVPlayer";
      return <div className={cn("flex items-center gap-4", align === "right" ? "flex-row-reverse" : "flex-row")}><span className={cn("text-[4vw] font-bold font-sriracha drop-shadow-md py-2 truncate max-w-[30vw]", colorClass)}>{name}</span></div>;
    };
    $[16] = getPlayerData;
    $[17] = oneVsOne;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  const PlayerLabel = t2;
  let t3;
  if ($[19] !== sport) {
    t3 = () => <img src={`/drawables/icon_${sport ? sport.toLowerCase() : "padel"}.png`} alt="Serve" className="w-[4vw] h-[4vw] object-contain ml-4" onError={_temp2} />;
    $[19] = sport;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  const ServeIcon = t3;
  let t4;
  bb0: {
    if (!gameState.timeStamp) {
      t4 = "";
      break bb0;
    }
    let t5;
    if ($[21] !== gameState.timeStamp) {
      t5 = new Date(gameState.timeStamp).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
      $[21] = gameState.timeStamp;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    t4 = t5;
  }
  const timeString = t4;
  let t5;
  if ($[23] !== PlayerLabel) {
    t5 = <div className="flex-1 flex justify-start min-w-0"><PlayerLabel spot={1} align="left" colorClass="text-[#529AFF]" /></div>;
    $[23] = PlayerLabel;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <img src="/drawables/mvplayer_logo.png" alt="MVP Logo" className="h-[8vw] w-auto object-contain drop-shadow-lg mx-4" />;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== PlayerLabel) {
    t7 = <div className="flex-1 flex justify-end min-w-0"><PlayerLabel spot={2} align="right" colorClass="text-[#529AFF]" /></div>;
    $[26] = PlayerLabel;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t5 || $[29] !== t7) {
    t8 = <div className="h-[12vw] flex items-center w-full px-4">{t5}{t6}{t7}</div>;
    $[28] = t5;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== homeSets) {
    t9 = <div className="h-[80%] aspect-square bg-[#529AFF] rounded-2xl flex items-center justify-center shrink-0 ml-4 shadow-lg"><span className="text-black text-[8vw] font-bold font-lato leading-none">{homeSets}</span></div>;
    $[31] = homeSets;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="text-white text-[5vw] font-bold font-sans tracking-tight truncate">HOME</span>;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== homeWon) {
    t11 = homeWon && <Trophy className="w-[5vw] h-[5vw] text-[#FFD700] ml-6 animate-bounce" />;
    $[34] = homeWon;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== ServeIcon || $[37] !== isHomeServing || $[38] !== matchFinished) {
    t12 = !matchFinished && isHomeServing && <ServeIcon />;
    $[36] = ServeIcon;
    $[37] = isHomeServing;
    $[38] = matchFinished;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== t11 || $[41] !== t12) {
    t13 = <div className="flex-1 flex items-center ml-8 min-w-0">{t10}{t11}{t12}</div>;
    $[40] = t11;
    $[41] = t12;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== matchFinished || $[44] !== setsData) {
    t14 = <div className="flex items-center h-full gap-4 mr-8">{setsData.map((set, idx) => <div key={idx} className="w-[10vw] flex justify-center"><span className={cn("text-[5vw] font-lato", matchFinished && set.h > set.v ? "font-bold text-[#529AFF]" : "font-normal text-white/60")}>{set.h}</span></div>)}</div>;
    $[43] = matchFinished;
    $[44] = setsData;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== homePointStr || $[47] !== matchFinished) {
    t15 = !matchFinished && <div className="h-full aspect-square bg-[#404040] rounded-2xl flex items-center justify-center shrink-0 border border-white/10 shadow-inner"><span className="text-white text-[10vw] font-bold font-lato tracking-tighter leading-none">{homePointStr}</span></div>;
    $[46] = homePointStr;
    $[47] = matchFinished;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  if ($[49] !== t13 || $[50] !== t14 || $[51] !== t15 || $[52] !== t9) {
    t16 = <div className="flex-1 bg-[#2A2A2A]/90 rounded-3xl p-4 flex items-center shadow-2xl border border-white/5 w-full relative">{t9}{t13}{t14}{t15}</div>;
    $[49] = t13;
    $[50] = t14;
    $[51] = t15;
    $[52] = t9;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  let t17;
  if ($[54] !== visitorSets) {
    t17 = <div className="h-[80%] aspect-square bg-[#ef4444] rounded-2xl flex items-center justify-center shrink-0 ml-4 shadow-lg"><span className="text-black text-[8vw] font-bold font-lato leading-none">{visitorSets}</span></div>;
    $[54] = visitorSets;
    $[55] = t17;
  } else {
    t17 = $[55];
  }
  let t18;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="text-white text-[5vw] font-bold font-sans tracking-tight truncate">VISITOR</span>;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== visitorWon) {
    t19 = visitorWon && <Trophy className="w-[5vw] h-[5vw] text-[#FFD700] ml-6 animate-bounce" />;
    $[57] = visitorWon;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== ServeIcon || $[60] !== isVisitorServing || $[61] !== matchFinished) {
    t20 = !matchFinished && isVisitorServing && <ServeIcon />;
    $[59] = ServeIcon;
    $[60] = isVisitorServing;
    $[61] = matchFinished;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  let t21;
  if ($[63] !== t19 || $[64] !== t20) {
    t21 = <div className="flex-1 flex items-center ml-8 min-w-0">{t18}{t19}{t20}</div>;
    $[63] = t19;
    $[64] = t20;
    $[65] = t21;
  } else {
    t21 = $[65];
  }
  let t22;
  if ($[66] !== matchFinished || $[67] !== setsData) {
    t22 = <div className="flex items-center h-full gap-4 mr-8">{setsData.map((set_0, idx_0) => <div key={idx_0} className="w-[10vw] flex justify-center"><span className={cn("text-[5vw] font-lato", matchFinished && set_0.v > set_0.h ? "font-bold text-[#ef4444]" : "font-normal text-white/60")}>{set_0.v}</span></div>)}</div>;
    $[66] = matchFinished;
    $[67] = setsData;
    $[68] = t22;
  } else {
    t22 = $[68];
  }
  let t23;
  if ($[69] !== matchFinished || $[70] !== visitorPointStr) {
    t23 = !matchFinished && <div className="h-full aspect-square bg-[#404040] rounded-2xl flex items-center justify-center shrink-0 border border-white/10 shadow-inner"><span className="text-white text-[10vw] font-bold font-lato tracking-tighter leading-none">{visitorPointStr}</span></div>;
    $[69] = matchFinished;
    $[70] = visitorPointStr;
    $[71] = t23;
  } else {
    t23 = $[71];
  }
  let t24;
  if ($[72] !== t17 || $[73] !== t21 || $[74] !== t22 || $[75] !== t23) {
    t24 = <div className="flex-1 bg-[#2A2A2A]/90 rounded-3xl p-4 flex items-center shadow-2xl border border-white/5 w-full relative">{t17}{t21}{t22}{t23}</div>;
    $[72] = t17;
    $[73] = t21;
    $[74] = t22;
    $[75] = t23;
    $[76] = t24;
  } else {
    t24 = $[76];
  }
  let t25;
  if ($[77] !== t16 || $[78] !== t24) {
    t25 = <div className="flex-1 flex flex-col gap-4 w-full my-2">{t16}{t24}</div>;
    $[77] = t16;
    $[78] = t24;
    $[79] = t25;
  } else {
    t25 = $[79];
  }
  let t26;
  if ($[80] !== PlayerLabel) {
    t26 = <div className="flex-1 flex justify-start min-w-0"><PlayerLabel spot={4} align="left" colorClass="text-[#ef4444]" /></div>;
    $[80] = PlayerLabel;
    $[81] = t26;
  } else {
    t26 = $[81];
  }
  let t27;
  if ($[82] !== timeString) {
    t27 = timeString && <div className="text-[#8E9285] text-[2.5vw] font-lato opacity-80 bg-white/5 px-6 py-2 rounded-xl mx-4">{timeString}</div>;
    $[82] = timeString;
    $[83] = t27;
  } else {
    t27 = $[83];
  }
  let t28;
  if ($[84] !== PlayerLabel) {
    t28 = <div className="flex-1 flex justify-end min-w-0"><PlayerLabel spot={3} align="right" colorClass="text-[#ef4444]" /></div>;
    $[84] = PlayerLabel;
    $[85] = t28;
  } else {
    t28 = $[85];
  }
  let t29;
  if ($[86] !== t26 || $[87] !== t27 || $[88] !== t28) {
    t29 = <div className="h-[12vw] flex items-center w-full px-4">{t26}{t27}{t28}</div>;
    $[86] = t26;
    $[87] = t27;
    $[88] = t28;
    $[89] = t29;
  } else {
    t29 = $[89];
  }
  let t30;
  if ($[90] !== t25 || $[91] !== t29 || $[92] !== t8) {
    t30 = <div className="w-full h-screen flex flex-col p-4 sm:p-6 bg-black select-none overflow-hidden">{t8}{t25}{t29}</div>;
    $[90] = t25;
    $[91] = t29;
    $[92] = t8;
    $[93] = t30;
  } else {
    t30 = $[93];
  }
  return t30;
}
function _temp2(e) {
  e.currentTarget.style.display = "none";
}
function _temp(p, opp) {
  if (p === 0) {
    return "0";
  }
  if (p === 15) {
    return "15";
  }
  if (p === 30) {
    return "30";
  }
  if (p === 40) {
    return "40";
  }
  if (p === 50) {
    return opp === 40 ? "Ad" : "40";
  }
  return p.toString();
}